import styled from 'styled-components';

export const ScreenViewerWrapper = styled.div`
  flex: 0 0 800px;
  padding: 10px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImgWrapper = styled.div`
  position: relative;
  border-radius: 24px;
  outline: 1px solid rgba(0, 0, 0, 0.2);
  overflow: hidden;

  img {
    box-shadow: none;
    display: block;
  }
`;

interface StyledClickableElementProps {
  $width: number;
  $height: number;
  $top: number;
  $left: number;
  $borderColor: string;
  $background: string;
  onClick?: () => void;
}

export const StyledClickableElement = styled.div<StyledClickableElementProps>`
  position: absolute;
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  border: 2px solid ${(props) => props.$borderColor};
  background: ${(props) => props.$background};
  cursor: pointer;
`;
